<sew-markdown [markdown]="markdownContent"></sew-markdown>
<div class="sew-dialog-button-group">
    <sew-button hierarchy="primary" website>
        <button (click)="confirm()">
            {{ 'ACTION.SECURITY_HINT.CONFIRM' | translate }}
        </button>
    </sew-button>
</div>
